import React from 'react';
import { Table, Tag, Typography } from 'antd';

import { formatMoney, formatUnits } from '../../../format';
import { AwaitingRepricing } from './orderColumns.jsx';
import { payoutRows } from './orderRows.js';

const { Text } = Typography;

/**
 * A redemption's payout accounts (LIV's split between banks): each bank
 * account with its split % and its share of the units and of the LKR paid
 * (orderRows.js payoutRows - the server's orders/payout-split.js, the payout
 * file's own rule). Shown in the transaction drawer and in its review, so the
 * reviewer sees exactly what each account will be paid. A figure the Core
 * has not priced yet reads "After pricing", as in the tables (US-05).
 *
 * Nothing is rendered for a transaction with no payout accounts.
 *
 * @param {{ detail: { order: object, payoutAccounts?: object[] } }} props
 */
const PayoutAccounts = ({ detail }) => {
    const { rows, amountLabel, totals } = payoutRows(detail);
    if (!rows.length) return null;
    const figure = (value, format) => (value === null ? <AwaitingRepricing /> : format(value));
    return (
        <Table
            className="order-payout-accounts"
            rowKey="key"
            size="small"
            pagination={false}
            dataSource={rows}
            columns={[
                { title: '#', dataIndex: 'seq', key: 'seq', width: 40 },
                {
                    title: 'Bank account',
                    key: 'account',
                    render: (_, r) => (
                        <span className="order-payout-account">
                            <div>{r.bank}{r.branch ? ' · ' + r.branch : ''}</div>
                            <Text type="secondary">{r.accountName}{r.account ? ' · ' + r.account : ''}</Text>
                            {!r.registered && <Tag color="orange">Not registered</Tag>}
                        </span>
                    )
                },
                { title: 'Split', dataIndex: 'splitPercent', key: 'split', align: 'right', render: (v) => (v === '' ? '—' : Number(v) + '%') },
                { title: 'Units', key: 'units', align: 'right', render: (_, r) => figure(r.units, formatUnits) },
                { title: amountLabel, key: 'amount', align: 'right', render: (_, r) => figure(r.amount, formatMoney) }
            ]}
            summary={() => (rows.length > 1 ? (
                <Table.Summary.Row>
                    <Table.Summary.Cell index={0} colSpan={3}><Text strong>Total</Text></Table.Summary.Cell>
                    <Table.Summary.Cell index={1} align="right">{totals.units === null ? '' : formatUnits(totals.units.toFixed(4))}</Table.Summary.Cell>
                    <Table.Summary.Cell index={2} align="right">{totals.amount === null ? '' : formatMoney(totals.amount.toFixed(2))}</Table.Summary.Cell>
                </Table.Summary.Row>
            ) : null)}
        />
    );
};

export default PayoutAccounts;
